module.exports = __webpack_public_path__ + "static/media/icone-azapfy.66ef1593.png";